"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Svg = exports.Label = exports.CheckboxStyled = exports.CheckboxHidden = void 0;

var _tokens = require("@superlogica/foundation/tokens");

var _utils = require("@superlogica/foundation/utils");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _CheckBox = _interopRequireDefault(require("./CheckBox.sizes"));

var _CheckBox2 = _interopRequireDefault(require("./CheckBox.theme"));

var CheckboxStyled = _styledComponents.default.div.withConfig({
  componentId: "sc-117z90l-0"
})(["transition:0.2s all linear;flex-shrink:0;display:flex;align-items:center;flex-direction:row;width:20px;height:20px;margin-right:", "px;border-radius:", "px;", ""], _tokens.spacing.horizontal.xxxs, _tokens.borderRadius.xs, function (_ref) {
  var theme = _ref.theme;
  return "\n\n    background-color: ".concat((0, _utils.parseColor)(theme.colors.ghost), ";\n\n    svg {\n      stroke: ").concat((0, _utils.parseColor)(theme.colors.ghost), ";\n    }\n    &.checked {\n      border-color: ").concat((0, _utils.parseColor)(theme.colors.primary), ";\n      background-color: ").concat((0, _utils.parseColor)(theme.colors.primary), ";\n      svg {\n        stroke: ").concat(_tokens.colors.neutral0, ";\n      }\n    }\n    &.disabled {\n      border-color: ").concat(_tokens.colors.neutral300, ";\n      background-color: ").concat(_tokens.colors.neutral100, ";\n      svg {\n        stroke: ").concat(_tokens.colors.ghost0, ";\n      }\n    }\n    &.checked.disabled {\n      background-color: ").concat(_tokens.colors.neutral300, ";\n      svg {\n        stroke: ").concat(_tokens.colors.neutral0, ";\n      }\n    }\n  ");
});

exports.CheckboxStyled = CheckboxStyled;

var Label = _styledComponents.default.label.withConfig({
  componentId: "sc-117z90l-1"
})(["cursor:pointer;vertical-align:top;display:inline-flex;flex-direction:row;align-items:center;", ""], function (_ref2) {
  var _themeSizes$size;

  var colorLabel = _ref2.colorLabel,
      labelFontSize = _ref2.labelFontSize,
      size = _ref2.size,
      theme = _ref2.theme,
      status = _ref2.status;
  var themeSizes = (0, _CheckBox.default)(theme);
  var checkBoxSize = (_themeSizes$size = themeSizes[size]) !== null && _themeSizes$size !== void 0 ? _themeSizes$size : themeSizes[theme.sizes.input];
  var typography = checkBoxSize.label;
  var color = (0, _CheckBox2.default)(colorLabel, theme.colors);
  var borderColor = (0, _CheckBox2.default)('neutral600', theme.colors);
  return (0, _styledComponents.css)(["font-family:'", "',sans-serif;font-size:", "px;font-weight:", ";letter-spacing:", "px;line-height:", "px;color:", ";", "{border-width:", "px;border-style:solid;border-color:", ";&.checked{border-color:", ";background:", ";}}"], theme.fonts.default, labelFontSize ? _tokens.fontSize[labelFontSize] : typography.fontSize, typography.fontWeight, typography.letterSpacing, typography.lineHeight, status ? color[status] : color.neutral, CheckboxStyled, _tokens.borderWidth.md, status ? borderColor[status] : borderColor.neutral, status ? borderColor[status] : (0, _utils.parseColor)(theme.colors.primary), status ? borderColor[status] : (0, _utils.parseColor)(theme.colors.primary));
});

exports.Label = Label;

var CheckboxHidden = _styledComponents.default.input.withConfig({
  componentId: "sc-117z90l-2"
})(["position:absolute;overflow:hidden;width:0;height:0;border:0;padding:0;margin:0;opacity:0;"]);

exports.CheckboxHidden = CheckboxHidden;

var Svg = _styledComponents.default.svg.withConfig({
  componentId: "sc-117z90l-3"
})(["margin:auto;"]);

exports.Svg = Svg;